import styled from 'styled-components';
export const BoardsContainer=styled.div`

`

export const BoardsHeader=styled.div`
display:flex;
justify-content:space-between;
.firstClass{
    display:flex;
    flex:0.3;
    justify-content:space-between;
}
.assessment{
    flex:0.5;
}
.secondClass{
    display:flex;
    flex:0.5;
    justify-content:space-between;
}
margin:30px 0px;
.child{
    display:flex;
    align-items:center;
    
}
.iconContainer{
    padding:8px 15px;
    border-radius:5px;
    &:hover{
        background-color:#5CE0D2;
        
    }
}
.icon{
    margin-right:10px;
}
`

export const ButtonWrapper=styled.div`
display:flex;
flex-wrap:nowrap;
flex-shrink:none;
border:1px solid #5CE0D2;
border-radius:10px;
overflow:hidden;
`
export const Button=styled.button`
border:none;
padding:8px 28px;
cursor:pointer;
display:inline-block;
background-color:transparent;
height:100%;
font-size:1rem;
border:1px solid #5CE0D2;
${({active})=>active&&`background-color:#5CE0D2;`}
`
export const SubjectsContainer=styled.div`


`
export const ChapterContainer=styled.div`


`